import { getMarketsUrlPath } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const MARKET_DETAIL_BY_PATH = "MARKET_DETAIL_BY_PATH_BY_PATH";

export function useMarketByUrlPathQuery(urlPath: string) {
	return useQuery({
		queryKey: [MARKET_DETAIL_BY_PATH, urlPath],
		queryFn: processResponse(() => getMarketsUrlPath(urlPath)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!urlPath,
	});
}
